module.exports = __webpack_public_path__ + "static/img/co2.b1d74dc0.png";